import React from 'react';

import { ArrowRight } from 'lucide-react';

type LocationCardProps = {
  label: string;
  subtitle: string;
  onClick: () => void;
};

export const LocationCard = ({ label, subtitle, onClick }: LocationCardProps) => {
  return (
    <button
      onClick={onClick}
      className="group flex flex-col gap-[6px] rounded-[20px] border-[1.4px] border-solid border-white px-[18px] py-[16px] transition-transform hover:scale-[1.1] max-md:gap-[2px] max-md:rounded-[12px] max-md:border max-md:px-2.5 max-md:py-2"
      style={{
        background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.30) 0%, rgba(255, 255, 255, 0.24) 100%)',
      }}
    >
      <div className="flex w-full items-center justify-between">
        <span className="text-left text-[16px] font-semibold leading-[1.4] tracking-[-0.352px] text-white max-md:truncate max-md:text-[12px] max-md:tracking-[-0.3px]">
          {label}
        </span>
        <ArrowRight className="h-5 w-5 text-white transition-transform max-md:h-3 max-md:w-3 max-md:shrink-0" />
      </div>
      <div className="flex items-start">
        <span className="text-left text-[13px] font-medium leading-[1.5] tracking-[-0.286px] text-[#FFFFFFB8] max-md:line-clamp-1 max-md:text-[10px] max-md:leading-[1.4] max-md:tracking-[-0.2px]">
          {subtitle}
        </span>
      </div>
    </button>
  );
};
